export const SIGNUP_SOURCE_RIBBIT = 'ribbit';
export const SIGNUP_SOURCE_REFERRAL = 'Referral';
